import { type Group } from "@entities";
import { groupRepo } from "@repositories";

export async function handleOpportunitiesSelect(
  opportunityIds: string[],
  group: Group | undefined,
  setAlertText: any,
  setSeverity: any,
) {
  try {
    if (!opportunityIds.length || !group) {
      return;
    }

    for (const opportunityId of opportunityIds) {
      const alreadyAdded = group.opportunities?.some(
        (event) => event?.opportunityId === opportunityId,
      );
      if (alreadyAdded) {
        continue;
      }

      await groupRepo.relations(group).opportunities.insert({ opportunityId });
    }

    setAlertText("המשימות עודכנו בהצלחה");
    setSeverity("success");
  } catch (e) {
    // eslint-disable-next-line no-console -- error handling
    console.error(e);
    setAlertText("אירעה שגיאה בעדכון המשימות");
    setSeverity("error");
  }
}
